import React from 'react';
import { Button, Tooltip } from 'antd';

const TooltipButton = ({ style, placement = 'bottom', tooltipText, onClick, type, icon, size, ...props }) => {
  return (
    <Tooltip placement={placement} styles={{ body: { fontSize: '12px' } }} title={tooltipText}>
      <Button
        style={{ ...style }}
        className={props.className}
        htmlType="button"
        onClick={onClick}
        type={type}
        icon={icon}
        size={size}
        {...props}
      >
        {props.children}
      </Button>
    </Tooltip>
  );
};

export default TooltipButton;
